/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { Field } from 'Util/Query';

/**
 * Brand Query
 * @class BrandQuery
 */
export class BrandQuery {
    __construct(){ super.__construct();
        this.options = {};
    }

    getQuery(options = {}) {
        this.options = options;
        const { attribute_code, options_id } = this.options;
        return new Field('brand')
            .addArgument('attribute_code', 'String!', attribute_code)
            .addArgument('options_id', 'String!', options_id)
            .addFieldList(this._getFields());
    }

    _getFields() {
        return [
            'option_setting_id',
            'filter_code',
            'value',
            'store_id',
            'title',
            'description',
            'short_description',
            'image',
            'image_mobile',
            'banner_link',
            'product_page_image',
            'product_page_image_mobile',
            'top_cms_block_id',
            'bottom_cms_block_content',
            'top_cms_block_content',
            'left_cms_block_id',
            'left_cms_block_content',
            'non_hero_grid_cms_block_id',
            'non_hero_grid_cms_block_content',
            'url_alias',
            'is_featured',
            'meta_title',
            'meta_description',
            'meta_keywords',
            'bottom_cms_block_id',
            'slider_position',
            'slider_image',
            'slider_image_desktop',
            'slider_image_mobile',
            'small_image_alt',
            'is_hero',
            'layout_type',
            'sort_by',
            'sort_direction'
        ];
    }
}

export default new BrandQuery();
